export default {
  COUPONS_USER_LOAD: 'COUPONS_USER_LOAD',
  COUPONS_USER_FETCHED: 'COUPONS_USER_FETCHED',
};
